import { useState } from "react";
import { useLoading } from "@fac/react-hooks";
import SerproService from "./Serpro.service";
import {
    ConsultPendenciesResponse,
    GetPendenciesProps,
    SerproMeiPendenciesDict,
    UserPendenciesDTO,
} from "./Serpro.type";
import APIService from "../API/API.service";

export const useGetPendencies = () => {
    // const [pendencies, setPendencies] = useState<SerproMeiPendenciesDict>({});
    const [pendencies, setPendencies] = useState<number>();
    const [dasPendencyValue, setDasPendencyValue] = useState<number>();
    const [dividaAtivaPendency, setDividaAtivaPendency] = useState<number>(0);
    const [detailedDasPendencies, setDetailedDasPendencies] = useState<{
        allDas: ConsultPendenciesResponse[];
    }>();

    const { wrapper, ...loadingProps } = useLoading();

    const getInterval = (start: number, end: number) => {
        const years = [];
        for (let year = start; year <= end; year += 1) {
            years.push(year.toString());
        }
        return years;
    };

    const getDasPendencies = async ({
        cnpj,
        dateInternal: { startDate, endDate },
    }: GetPendenciesProps) => {
        const years = getInterval(startDate, endDate);
        const response = await SerproService.getDasPartialPendencies(cnpj);

        if (response) {
            const res = response.data as {
                allDas: ConsultPendenciesResponse[];
            };
            let totalValue = 0;
            for (const das of res.allDas) {
                totalValue += das.detalhamento[0].valores.total;
            }
            setDasPendencyValue(totalValue);
            // setPendencies(totalValue);
            setDetailedDasPendencies(res);
        }
    };

    const sentCompleteDASPendenciesToEmail = async (data: {
        cnpj: string;
        email: string;
        name: string;
    }) => {
        const response = await SerproService.getDasCompletePendencies(data);
        console.log(response.data)
    };

    const getDividaAtivaPendencies = ({ cnpj }: { cnpj: string }) => {
        wrapper(async () => {
            const response = await SerproService.getDividaAtivaPendencies(cnpj);
            if (response) {
                const totalPendency = response.data as number;
                setDividaAtivaPendency(totalPendency);
                setPendencies(totalPendency);
                await APIService.setPendencyValue({
                    cnpj,
                    date: new Date().toLocaleDateString('pt-br'),
                    pendencyType: 'valorDividaAtiva',
                    value: totalPendency.toString()
                })
            }
        });
    };

    const sendDasPendenciesEmail = async ({ pdfs, name, email }: UserPendenciesDTO) => {
        const response = await SerproService.sendPendenciesEmail({
            pdfs,
            name,
            email,
        });
    };

    const getCCMEI = async (cnpj: string) => {
        return await SerproService.getCCMEI(cnpj);
    };

    return {
        pendencies,
        detailedDasPendencies,
        setPendencies,
        setDividaAtivaPendency,
        getDasPendencies,
        getDividaAtivaPendencies,
        dividaAtivaPendency,
        sendDasPendenciesEmail,
        sentCompleteDASPendenciesToEmail,
        getCCMEI,
        dasPendencyValue,
        ...loadingProps,
    };
};

export const GOVHooks = {
    useGetPendencies,
};
